const DUOTONES: [string, string][] = [
  ["#7C3AED", "#00E5FF"], ["#00E5FF", "#34d399"], ["#a855f7", "#3B6CF6"],
  ["#3B6CF6", "#10D7F2"], ["#7C3AED", "#34d399"], ["#10D7F2", "#a855f7"],
];

const hashStr = (s: string) => {
  let h = 7;
  for (const c of s) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return h;
};

export const authorDuotone = (key: string): [string, string] =>
  DUOTONES[hashStr(key || "nl") % DUOTONES.length];

export const AuroraAvatar = ({ name, avatarUrl, seed, className = "h-20 w-20 sm:h-24 sm:w-24", textClass = "text-2xl", animate = true }: {
  name: string; avatarUrl?: string | null; seed?: string; className?: string; textClass?: string; animate?: boolean;
}) => {
  const [c1, c2] = authorDuotone(seed || name);
  const initials = (name || "?").split(" ").map((w) => w[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();
  return (
    <div className={`relative shrink-0 ${className}`} data-testid="author-avatar-halo">
      <div aria-hidden className="absolute -inset-1 rounded-full opacity-50 blur-md"
        style={{ background: `conic-gradient(from 0deg, ${c1}, ${c2}, ${c1})` }} />
      <div aria-hidden
        className={`absolute inset-0 rounded-full ${animate ? "animate-[spin_9s_linear_infinite] motion-reduce:animate-none" : ""}`}
        style={{ background: `conic-gradient(from 0deg, ${c1}, ${c2} 45%, rgba(255,255,255,0.12) 60%, ${c1})` }} />
      <div className="absolute inset-[3px] rounded-full bg-[#050506]" />
      {avatarUrl ? (
        <img src={avatarUrl} alt={name} data-testid="author-avatar"
          className="absolute inset-[6px] h-[calc(100%-12px)] w-[calc(100%-12px)] rounded-full object-cover" />
      ) : (
        <div className="absolute inset-[6px] rounded-full flex items-center justify-center"
          style={{ background: `linear-gradient(135deg, ${c1}cc, ${c2}cc)` }}>
          <span className={`font-heading font-black text-white ${textClass}`}>{initials}</span>
        </div>
      )}
    </div>
  );
};
